import { useAtom } from "jotai";
import { visitedTabsAtom } from "@design-lab/shared/lib/tab-navigation";

export const useVisitedTabs = () => useAtom(visitedTabsAtom);
